import FormulateVueSelect from './FormulateVueSelect.vue'

/**
 * Plugin que registra o tipo "vue-select" do Vue Formulate com uma
 * implementação própria, cujo filtro ignora acentos na busca das opções.
 *
 * É o único provedor do tipo "vue-select": usa a mesma versão do vue-select
 * registrada globalmente em `main.js`, evitando conflito de versões.
 */
export default function VueFormulateVueSelectPlugin(formulateInstance) {
  formulateInstance.extend({
    components: {
      FormulateVueSelect,
    },
    library: {
      'vue-select': {
        classification: 'search',
        component: 'FormulateVueSelect',
      },
    },
  })
}
